/**
* Project janux-vuejs-seed
* Created by hielo on 2018-05-10
*/

<template lang="pug">
	div

		fieldset(v-for="(address, index) in data.contactMethods.addresses")

			.field-title(:class="{errorContactLabel: !address.line1 && isCheckout}") Address line 1
				span(v-if="isRequired") &nbsp;*
			// .error-val.error-contact(v-if="!address.line1") Enter the address *
			.each-field-contact: b-form-input.all-fields(v-model='address.line1', @input="validate",  :class="{errorInField: !address.line1 && isCheckout}")

			.field-title Address line 2
			// .error-val.error-contact(v-if="!address.line2") Enter the address
			.each-field-contact: b-form-input.all-fields(v-model='address.line2', @input="validate")

			.field-title(:class="{errorContactLabel: !address.cityText && isCheckout}") City
				span(v-if="isRequired") &nbsp;*
			// .field-title(v-if="address.cityText") City
			// .error-val.error-contact(v-if="!address.cityText") Enter the city
			.each-field-contact: b-form-input.all-fields(v-model="address.cityText", @input="validate", :class="{errorInField: !address.cityText && isCheckout}" )

			.state-zip-row
				.left-side
					.field-title(:class="{errorContactLabel: !address.stateText && isCheckout}") State
						span(v-if="isRequired") &nbsp;*
					// .error-val.error-contact(v-if="!address.stateText") Enter the state
					.each-field-contact: b-form-input.all-fields(v-model="address.stateText", @input="validate", :class="{errorInField: !address.stateText && isCheckout}")
				.right-side
					// .field-title(v-if="address.postalCode") Zip Code
					.field-title(:class="{errorContactLabel: !address.postalCode && isCheckout}") Zip Code
						span(v-if="isRequired") &nbsp;*
					// .error-val.error-contact(v-if="!address.postalCode") Enter the postal code
					.each-field-contact: b-form-input.all-fields(v-model='address.postalCode', @input="validate", :class="{errorInField: !address.postalCode && isCheckout}")

</template>

<script>
import {PostalAddress} from 'janux-people'

export default {
	name: 'jnx-address',
	props: ['sectionTitle', 'data', 'isValid', 'isCheckout', 'isRequired'],
	data () {
		return {
			addressTypes: ['HOME', 'WORK', 'OTHER']
		}
	},
	methods: {
		removeAddress (index) {
			this.data.contactMethods.addresses.splice(index, 1)
		},
		addNewAddress () {
			this.data.setContactMethod('work', new PostalAddress())
		},
		validate () {
			this.isValid.address = !!(
				this.data.postalAddress().line1 &&
				this.data.postalAddress().cityText &&
				// this.data.postalAddress().stateText &&
				this.data.postalAddress().postalCode
			)
			let iterate = true
			Object.keys(this.isValid).forEach(key => {
				if (key !== 'result') {
					if (!this.isValid[key] && iterate) {
						iterate = false
						this.isValid.result = false
					} else if (this.isValid[key] && iterate) {
						this.isValid.result = true
					}
				}
			})
		}
	},
	beforeMount () {
		this.validate()
	},
	computed: {
		componentTitle () {
			return this.$t(this.sectionTitle)
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../../easytitle24-2.x-common/components/party/address.vue